import { md5 } from '../../shared/md5';

const STORAGE_KEY = 'asknow.authKey';
const AUTH_HEADER = 'X-Auth-Key';

export class AuthService {
  private cachedKey: string | null = null;

  constructor(private storage: Storage = window.localStorage) {
    this.cachedKey = this.storage.getItem(STORAGE_KEY);
  }

  ensureAuthKey(): string {
    let key = this.cachedKey || this.storage.getItem(STORAGE_KEY);

    while (!key) {
      const input = window.prompt('Enter access key to continue:')?.trim() ?? '';
      if (!input) {
        window.alert('An auth key is required to use this application.');
        continue;
      }

      key = input;
      this.storage.setItem(STORAGE_KEY, key);
      this.cachedKey = key;
    }

    return key;
  }

  getHashedKey(): string {
    const key = this.ensureAuthKey();
    return md5(key);
  }

  applyAuthHeader(init: RequestInit = {}): RequestInit {
    const headers = new Headers(init.headers ?? {});
    headers.set(AUTH_HEADER, this.getHashedKey());
    return { ...init, headers };
  }

  clearAuthKey(): void {
    this.cachedKey = null;
    this.storage.removeItem(STORAGE_KEY);
  }

  async handleUnauthorized(): Promise<void> {
    this.clearAuthKey();
    window.alert('Authentication failed. Please enter a valid auth key to continue.');
    this.ensureAuthKey();
  }
}

export const AUTH_HEADER_NAME = AUTH_HEADER;
